msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: da\n"
"Project-Id-Version: 69ffe877770b8fde5aa44a8b4a76deba\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Danish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 69ffe877770b8fde5aa44a8b4a76deba\n"
"X-Crowdin-Project-ID: 550\n"
"X-Crowdin-Language: da\n"
"X-Crowdin-File-ID: 25212\n"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:32
#: src/components/Ad/lib/formatDistance.ts:49
msgid "distance.with-unit"
msgstr "{distance} km"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:13
msgid "distance.in-meters"
msgstr "{distance} meter"

#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:24
#: src/components/Ad/lib/formatDistance.ts:39
msgid "distance.mobility-unit"
msgstr "{distance} mil"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:61
msgid "explore.filter.range.label"
msgstr "Prisinterval: {filterName}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:82
msgid "filters.range.maximum.label"
msgstr "{filterName}, maksimum"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:68
msgid "filters.range.minimum.label"
msgstr "{filterName}, minimum"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:626
#: src/islands/search/SearchBar.tsx:622
msgid "explore.searchInput.filters.range.both"
msgstr "{min}-{max}"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:7
msgid "distance.less-than-100m"
msgstr "100 meter eller derunder"

#. js-lingui-explicit-id
#: src/components/Ad/AdImageWrapper.tsx:22
msgid "search.ad.recommerce.image-alt"
msgstr "Annoncebillede"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:120
msgid "explore.filters.all"
msgstr "Alle"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:134
#: src/islands/search/FiltersModal.tsx:141
msgid "explore.searchInput.filters.title"
msgstr "Alle filtre"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:853
msgid "explore.searchInput.filters.apply"
msgstr "Anvend"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:24
#: src/islands/header/Header.tsx:33
#: src/islands/search/StickySearchBar.tsx:76
#: src/islands/search/StickySearchBar.tsx:85
msgid "explore.back.button"
msgstr "Tilbage"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:127
msgid "explore.suggestions.title"
msgstr "Baseret på din søgning"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:135
msgid "explore.results.title"
msgstr "Baseret på din søgning"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:54
msgid "explore.header.badge"
msgstr "Beta"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:866
msgid "explore.searchInput.filters.clear.single"
msgstr "Ryd"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:841
msgid "explore.searchInput.filters.clear"
msgstr "Ryd alle"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:763
#: src/islands/search/SearchBar.tsx:778
msgid "explore.searchInput.clear"
msgstr "Ryd tekst"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:176
#: src/islands/search/FiltersModal.tsx:181
msgid "explore.searchInput.filters.close"
msgstr "Luk filtre"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:52
msgid "explore.results.errorstate.network.heading"
msgstr "Forbindelsesfejl"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:74
msgid "explore.suggestions.title.discover.more"
msgstr "Find mere"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:48
msgid "explore.header.title"
msgstr "Udforsk"

#. js-lingui-explicit-id
#: src/server/server.ts:170
msgid "page.title"
msgstr "Udforsk – find din næste handel på Markedspladsen med AI"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:58
msgid "explore.sorting.info.body-try-it-two"
msgstr "Udforsk-funktionen analyserer al information i en annonce, herunder billeder, når den søger efter resultater. Den traditionelle søgefunktion på DBA søger derimod kun i annonceteksten."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:55
msgid "explore.sorting.info.title-two"
msgstr "Udforsk-funktionen analyserer tekst og billeder"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:26
msgid "explore.results.errorstate.server.message"
msgstr "Udforsk-funktionen fungerer ikke lige nu, men vi arbejder på sagen. Prøv igen senere!"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:36
msgid "explore.sorting.info.body-one"
msgstr "Udforsk-funktionen bruger AI til at forstå, hvad du leder efter. I modsætning til den normale søgefunktion på markedsplatsen, som kun viser resultater med det præcise søgeord, får du med Udforsk-funktionen en meget bredere søgning, der forsøger at ramme din hensigt fremfor blot søgeordet."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:57
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:60
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:86
msgid "explore.filter.fallback"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:137
msgid "explore.searchInput.filters.back"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:824
msgid "explore.searchInput.filters"
msgstr "Filtre"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:22
msgid "explore.sorting.info.trigger"
msgstr "Find ud af, hvordan det fungerer"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:61
msgid "explore.prompt.subtitle"
msgstr "Find din næste handel på Markedspladsen med AI"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:638
#: src/islands/search/SearchBar.tsx:628
#: src/islands/search/SearchBar.tsx:687
msgid "explore.searchInput.filters.range.min"
msgstr "Fra {value}"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:70
msgid "explore.results.feedback.followup.button"
msgstr "Giv feedback"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:79
msgid "explore.results.errorstate.goback.label"
msgstr "Gå tilbage for at søge på Markedspladsen"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:143
msgid "explore.results.count.hits"
msgstr "resultater"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:29
msgid "explore.sorting.title"
msgstr "Sådan fungerer Udforsk-funktionen"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:98
#: src/islands/suggestions/Suggestions.tsx:165
msgid "explore.suggestions.buttons.loading"
msgstr "Indlæser forslag"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:56
msgid "explore.suggestions.placeholder"
msgstr "Indlæser ..."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:111
msgid "explore.searchInput.filters.range.max.label"
msgstr "Maks. værdi"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:107
msgid "explore.searchInput.filters.range.min.label"
msgstr "Min. værdi"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:102
msgid "explore.results.feedback.negative.label"
msgstr "Negativ feedback"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:707
msgid "explore.searchInput.filters.empty"
msgstr "Ingen tilgængelige filtre"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:30
msgid "explore.results.zero-results.alt-text"
msgstr "Ingen søgeresultater"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:36
msgid "explore.results.zero-results.heading"
msgstr "Ingen søgeresultater"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:37
msgid "explore.results.errorstate.client.heading"
msgstr "Åh nej!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:92
msgid "explore.results.feedback.positive.label"
msgstr "Positiv feedback"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:60
msgid "explore.filter.price.label"
msgstr "Prisinterval"

#. js-lingui-explicit-id
#: src/server/server.ts:171
msgid "page.description"
msgstr "Markedsplads-side, der muliggør semantisk søgning til udforskning"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:742
#: src/islands/search/SearchBar.tsx:791
msgid "explore.searchInput.ariaLabel"
msgstr "Søg"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:69
msgid "explore.sorting.info.body-try-it-two-rest"
msgstr "Søg efter \"Tøj til en sommerfest med arbejdet\", og lad Udforsk-funktionen foreslå tøj til lejligheden."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:33
msgid "explore.sorting.info.title-one"
msgstr "Søgeresultater baseret på hensigt"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:855
msgid "explore.searchInput.calloutText"
msgstr "Søg med en sætning"

#. js-lingui-explicit-id
#: src/components/Ad/AdLocation.tsx:20
msgid "search.ad.bap.sold"
msgstr "Solgt"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:41
msgid "explore.results.errorstate.client.message"
msgstr "Noget gik galt, og vi kunne ikke indlæse nogen varer. Prøv igen."

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:22
msgid "explore.results.errorstate.server.heading"
msgstr "Beklager!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:26
msgid "explore.results.feedback.followup.negative"
msgstr "Tak! Har du lyst til at uddybe, hvad du ikke synes godt om?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:21
msgid "explore.results.feedback.followup.positive"
msgstr "Tak! Vil du fortælle os mere om, hvad du synes godt om?"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:98
msgid "explore.filter.range.invalid"
msgstr "Maksimumsværdien kan ikke være mindre end minimumsværdien."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:795
msgid "explore.searchInput.helpText"
msgstr "Tip: Brug beskrivende sætninger"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:136
#: src/islands/results/ErrorState.tsx:142
msgid "explore.results.errorstate.retry.label"
msgstr "Prøv igen"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:45
#: src/islands/results/SortingInfo.tsx:67
msgid "explore.sorting.info.try-it"
msgstr "Prøv selv!"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:131
msgid "explore.suggestions.title.discover"
msgstr "Prøv at søge efter"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:43
msgid "explore.results.zero-results.message"
msgstr "Prøv at omformulere din søgning eller justere dine filtre, hvis du ikke fandt det, du søgte i første forsøg."

#. js-lingui-explicit-id
#: src/components/Ad/AdImageOptions.tsx:15
msgid "search.ad.fallback-image-alt"
msgstr "To bjerge og en sky"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:47
msgid "explore.sorting.info.body-try-it-one-rest"
msgstr "Skriv \"vintage køkkenudstyr\", og lad Udforsk-funktionen foreslå relevante annoncer for f.eks. vintage service, lamper og indretningsartikler."

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:82
#: src/islands/suggestions/Suggestions.tsx:149
msgid "explore.suggestions.title.error"
msgstr "Kunne ikke indlæse forslag. Prøv igen."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:647
#: src/islands/search/SearchBar.tsx:634
#: src/islands/search/SearchBar.tsx:689
msgid "explore.searchInput.filters.range.max"
msgstr "Op til {value}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:878
msgid "explore.searchInput.filters.use"
msgstr "Anvend"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:110
#: src/islands/results/ErrorState.tsx:116
msgid "explore.results.errorstate.help.center.label"
msgstr "Besøg vores hjælpecenter"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:56
msgid "explore.results.errorstate.network.message"
msgstr "Vi kunne ikke oprette forbindelse til vores servere. Kontrollér din internetforbindelse, og prøv igen."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:787
msgid "explore.searchInput.placeholder"
msgstr "Hvad leder du efter?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:83
msgid "explore.results.feedback.prompt"
msgstr "Hvad synes du om Udforsk-funktionen?"

